module.exports = __webpack_public_path__ + "img/01-1数据湖仓技术.df376c23.png";